import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import { FirebaseAppProvider } from "reactfire";
import firebaseManager from "./model/Firebase/FirebaseManager";

ReactDOM.render(
  <FirebaseAppProvider firebaseManager={firebaseManager}>
    <Suspense fallback={<div></div>}>
      <App />
    </Suspense>
  </FirebaseAppProvider>,
  document.getElementById("root")
);
